import { useSelector } from 'react-redux';

export const useModalBodyTableReconciliation = () => {
    //@ts-ignore
    const { financial_info } = useSelector((state) => state.dashboardReducer);
    return { sign: financial_info.currency.short_code };
};
